import React from 'react';

import { DetailsDropdownMenu } from '@neptune/entity-common-ui';
import { useUnderEditContext } from '@neptune/shared/common-business-logic';
import { Entity } from '@neptune/shared/entity-domain';
import { WithPermissions } from '@neptune/shared/project-domain';
import { ActionsMenu } from '@neptune/shared/venus-ui';

import { DetailsDropdownMenuContentContainer } from './DetailsDropdownMenuContentContainer';

type Props = {
  name?: string;
  alias?: string;
  isAliasEditable?: boolean;
  isColorEditable?: boolean;
  isSaving?: boolean;
  onCopy?: () => void;
  entityWithPermissions: WithPermissions<Entity>;
  onAliasChange?: (alias: string) => void;
  align?: React.ComponentProps<typeof ActionsMenu.Content>['align'];
  side?: React.ComponentProps<typeof ActionsMenu.Content>['side'];
  manageTagsAttributeNames?: string[];
};

export const DetailsDropdownMenuContainer = ({
  name,
  alias,
  isAliasEditable,
  isColorEditable,
  isSaving,
  onCopy,
  entityWithPermissions,
  onAliasChange,
  align,
  side,
  manageTagsAttributeNames,
}: Props) => {
  const [open, setOpen] = React.useState(false);

  const { startEdit, stopEdit } = useUnderEditContext();

  const handleOpenChange = React.useCallback(
    (open: boolean) => {
      if (open) {
        startEdit();
      } else {
        stopEdit();
      }

      setOpen(open);
    },
    [startEdit, stopEdit],
  );

  const handleMenuClose = React.useCallback(() => {
    handleOpenChange(false);
  }, [handleOpenChange]);

  // TODO: remove once extended for other object types
  if (entityWithPermissions.type !== 'run') {
    return null;
  }

  return (
    <DetailsDropdownMenu open={open} onOpenChange={handleOpenChange}>
      <DetailsDropdownMenuContentContainer
        align={align}
        side={side}
        name={name}
        alias={alias}
        isAliasEditable={isAliasEditable}
        isColorEditable={isColorEditable}
        isSaving={isSaving}
        onCopy={onCopy}
        entityWithPermissions={entityWithPermissions}
        onAliasChange={onAliasChange}
        onMenuClose={handleMenuClose}
        manageTagsAttributeNames={manageTagsAttributeNames}
      />
    </DetailsDropdownMenu>
  );
};
